$(function(){
    $('#galleryPage').on('shown.bs.modal', function(){
        
        $('[data-bs-spy="scroll"]').each(function () {
            var $spy = $(this).scrollspy('refresh')
        });
    });
});